export const setDateTimeToZero = (date: Date | number): Date => {
  const dateObj = new Date(typeof date === 'number' ? date : date.getTime());
  dateObj.setHours(0, 0, 0, 0);
  return dateObj;
};

export const adjustDateTimeByTimezoneOffset = (date: Date): string => {
  const dateFormatISO = date instanceof Date ? date : new Date(date);
  const localTimezoneDif = dateFormatISO.getTimezoneOffset();
  const adjustedTime = new Date(dateFormatISO.getTime() + localTimezoneDif * 60 * 1000);
  return `${adjustedTime.getFullYear()}-${
    adjustedTime.getMonth() + 1
  }-${adjustedTime.getDate()}T${adjustedTime.getHours()}:${adjustedTime.getMinutes()}:00+00:00`;
};

export const formatDateToUTC = (date: Date): Date => {
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
};
